import { Button, CloseIcon, JoonUIColor, SPACING } from "@joonapp/web-shared"
import { create } from "zustand"

import useMobile from "../../hooks/useMobile"
import SlideUpModal from "../slideUpModal/SlideUpModal"

interface SmallImageModalStore {
  isOpen: boolean
  onOpen: (imageUrl: string) => void
  onClose: () => void
  imageUrl: string | null
}

export const useSmallImageModalStore = create<SmallImageModalStore>((set) => ({
  isOpen: false,
  onOpen: (imageUrl) => set({ isOpen: true, imageUrl }),
  onClose: () => set({ isOpen: false, imageUrl: "" }),
  imageUrl: null,
}))

export const SmallImageModal = () => {
  const { isOpen, imageUrl, onClose } = useSmallImageModalStore()
  const isMobile = useMobile()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      backgroundType="overlay"
      zIndex={1100}
      size={isMobile ? "full-height" : "fit-content"}
    >
      <div className="flex flex-col items-center justify-center bg-black w-full h-full">
        <div
          style={{
            position: "absolute",
            right: SPACING.space4,
            top: SPACING.space4,
          }}
        >
          <Button
            onClick={onClose}
            text={
              <div style={{ height: "20px" }}>
                <CloseIcon color={JoonUIColor.text.inverted} />
              </div>
            }
            style={{ padding: SPACING.space2 }}
            size="small"
          />
        </div>
        <img src={imageUrl || ""} alt="Magnified view" className="w-[70%]" />
      </div>
    </SlideUpModal>
  )
}
